import ContactsIcon from './ContactsIcon';

export default ContactsIcon;
